module.exports = function (fox, _publicPath_) {
 /* fox-dynamic-injection */ 
fox.registerTemplate("layout_common", [["section",{"class":"promo-wrapper &&0&&"},[["header",{"class":"promo-header scrolled"}],["section",{"class":"common-content","id":"container"}],["footer",{"class":"common-footer"}]],[["cookie.mc_lang","class",false,[],"env"]]]]);
 /* fox-dynamic-injection */ 
};


//////////////////
// WEBPACK FOOTER
// /var/www/jenkins.devel.ac/workspace/MC_Frontend_Rollout/node_modules/fox-dynamic-injection!/var/www/jenkins.devel.ac/workspace/MC_Frontend_Rollout/node_modules/fox-template-loader?interpolate!./templates/layout/common.tpl
// module id = 31
// module chunks = 2